// LICENSE_CODE ZON
'use strict';

/*jslint browser:true*/
define(['/www/hola/pub/util.js', '/www/hola/pub/gtm', '/util/etask.js', 'pub_config', '/www/hola/pub/be.js', '/svc/account/pub/membership.js', '/util/user_agent.js', '/util/storage.js', '/util/url.js', 'cookie'], function (www_util, gtm, etask, config, be, membership, user_agent, storage, zurl, cookie) {
  var E = {};
  var assign = Object.assign;
  var browser = user_agent.guess_browser();
  var origins = [/^https?:\/\/(.*\.)?(hola\.org|h-cdn\.com)$/, 'app://hola-ui', 'chrome-extension://pdehmppfilefbolgganhfihpbmjlgebh', 'chrome-extension://plemmnofmhlcckpejimdohkmbbcfcodj', 'chrome-extension://pnknnijoleibcpmkdcooclmnjmmdhgbg', 'chrome-extension://gkojfkhlekighikafcpjkiklfbnlmeio', 'chrome-extension://bbjkgcbckkalmlpimfinpdmaelnknlee', 'chrome-extension://mhcmfkkjmkcfgelgdpndepmimbmkbpfp', 'chrome-extension://bbjkgcbckkalmlpimfinpdmaelnknlee', 'resource://jid1-4p0kohsjxu1qgg-at-jetpack', 'resource://ff_ext-at-hola-dot-org'];
  function is_hola_origin(msg_origin) {
    for (var i = 0; i < origins.length; i++) {
      if (typeof origins[i] == 'string' && msg_origin == origins[i] || origins[i].test && origins[i].test(msg_origin)) {
        return true;
      }
    }
    return false;
  }

  // XXX bahaa: use backbone models from be.js to get extension info
  function ext_is_installed(opt) {
    opt = assign({
      timeout: 1000,
      tries: 1
    }, opt);
    var l,
      tries = 0;
    function cleanup() {
      if (l) window.removeEventListener('message', l);
      l = null;
    }
    return etask([function check() {
      var info,
        _this = this;
      if (!opt.msg_only && (info = config.get_hola_extension_info()) && (!opt.ver || opt.ver == info.ver)) {
        return E.ga_track_installed();
      }
      if (tries++ >= opt.tries) return this.return(false);
      window.addEventListener('message', l = function l(e) {
        if (!is_hola_origin(e.origin)) return;
        var d = e.data;
        if (d && d.data && d.id == 'ping' && (!opt.ver || opt.ver == d.data.ver) && /^hola_(chrome|firefox)$/.test(d.src)) {
          return _this.return(E.ga_track_installed());
        }
      }, '*');
      window.postMessage({
        src: 'hola_ccgi',
        id: 'ping',
        data: {}
      }, '*');
      return this.wait(opt.timeout);
    }, function catch$(err) {
      cleanup();
      if (err == 'timeout') return this.goto('check');
      throw err;
    }, function finally$() {
      cleanup();
    }]);
  }
  E.ga_track_installed = function () {
    return etask([function () {
      if (E.ga_virtual_pageview.triggered && E.ga_virtual_pageview.triggered.ext_is_installed) {
        return this.goto('end');
      }
    }, function () {
      E.ga_virtual_pageview('ext_is_installed');
    }, function end() {
      return this.return(true);
    }]);
  };
  E.ga_virtual_pageview = function (page_name) {
    var ga_url = '_virt_' + page_name;
    E.ga_virtual_pageview.triggered = E.ga_virtual_pageview.triggered || {};
    if (E.ga_virtual_pageview.triggered[page_name]) return;
    gtm.push({
      event: 'virt_pageview',
      virt_url: ga_url
    });
    E.ga_virtual_pageview.triggered[page_name] = true;
  };

  // XXX arik: this function takes time (ext_is_installed may take 1sec).
  // we might never send track download at the end
  E.ga_track_download_send = function (name, origin_name, _url, next, page_url, opt) {
    if (!opt) opt = {};
    name = name || 'unknown';
    origin_name = origin_name || 'unknown';
    _url = _url || origin_name;
    page_url = page_url || location.href;
    E.ga_virtual_pageview('track_download?b=' + name);
    storage.set('track_download_event', 1);
    be.set_svc_downloaded();
    etask([function () {
      if (origin_name == 'inline_err') return this.continue();
    }, function () {
      return etask.all({
        ext_installed: ext_is_installed(),
        login: www_util.get_user({
          cache: true,
          nosync: true
        }),
        membership: www_util.get_membership({
          cache: true,
          nosync: true
        })
      });
    }, function (res) {
      var info = be.product_info();
      var is_logged_in = !!res.login.user;
      var is_plus = is_logged_in && membership.is_active(res.membership);
      var build = {
        url: _url
      };
      if (opt.hola_browser) www_util.perr({
        id: 'www_track_download_hola_browser'
      });
      // XXX sergeir: we can use different campaign in filename
      var c = opt.filename && opt.filename.match(/-c-([A-Za-z0-9]+)/);
      if (c && c[1]) build.campaign = c[1];else if (!cookie.get('c_browser') && !cookie.get('c_vpn') && location.pathname == '/') {
        build.campaign = 'hp';
      }
      gtm.push({
        event: 'install_download',
        url: _url,
        browser: browser,
        campaign: build.campaign
      });
      return www_util.perr({
        id: 'www_track_download',
        info: {
          by_link: opt.by_link,
          name: name,
          url: _url,
          original_url: opt.original_url,
          filename: opt.filename,
          page_url: page_url,
          pathname: location.pathname,
          ref: page_url && zurl.qs_parse_url(page_url, {
            safe: true
          }).ref,
          ext_installed: !!res.ext_installed,
          ext_cid: info.cid,
          browser: browser,
          origin_name: origin_name,
          user_info: {
            is_logged_in: is_logged_in,
            is_plus: is_plus
          },
          agree: opt.agree,
          install_opt: opt,
          sync_device_id: opt.sync_device_id
        },
        build: build
      });
    }, function finally$() {
      if (next) next();
    }]);
  };
  return E;
});